import { render } from "./FrontStudentInfoModal.vue?vue&type=template&id=0f640f70&scoped=true"
import script from "./FrontStudentInfoModal.vue?vue&type=script&lang=js"
export * from "./FrontStudentInfoModal.vue?vue&type=script&lang=js"

import "./FrontStudentInfoModal.vue?vue&type=style&index=0&id=0f640f70&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Desktop\\project\\sparta\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f640f70"]])

export default __exports__